import BookSummary from './BookSummary';

export default BookSummary;